<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    title="模版选择"
    width="1200px"
    height="650px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
  >
    <div class="search">
      <el-form ref="searchForm" :inline="true" label-width="0" :model="searchModel" size="small">
        <el-form-item label="" prop="keyword">
          <el-input v-model.trim="searchModel.keyword" placeholder="输入模版名称" clearable />
        </el-form-item>
        <el-form-item label="" prop="isDefault">
          <el-select v-model="searchModel.isDefault" placeholder="选择是否默认模版" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" size="small" @click="getList(true)">查询</el-button>
          <el-button icon="el-icon-refresh-right" size="small" @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      ref="table"
      v-loading="tableLoading"
      :data="tableData"
      size="small"
      border
      stripe
      style="width: 100%"
      empty-text="暂无数据"
    >
      <el-table-column label="序号" align="center" width="50" fixed>
        <template v-slot="{ $index }">
          <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="模版名称" prop="title" min-width="120" header-align="center" fixed></el-table-column>
      <el-table-column label="是否为默认模版" width="140" align="center">
        <template v-slot="{ row }">
          <el-tag v-if="row.isDefault == 1" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" min-width="180" header-align="center"></el-table-column>
      <el-table-column label="创建/修改人" width="140" align="center" prop="createByName"></el-table-column>
      <el-table-column label="创建/修改时间" width="160" align="center" prop="updatetime"></el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template v-slot="{ row }">
          <el-button type="success" size="mini" plain icon="el-icon-picture" @click="handlePreview(row)">预览</el-button>
          <el-button type="primary" size="mini" plain icon="el-icon-circle-check" @click="handleChoose(row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination" style="margin: 20px 0; display: flex; justify-content: center">
      <el-pagination
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        :total="tableTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 模版预览 弹窗 -->
    <HiprintPreview preview-id="center_preview_html" :visible.sync="previewVisible" :activeInfo="activeRowInfo" />
  </drag-dialog>
</template>

<script>
import HiprintPreview from './HiprintPreview';

import { providerList } from '../basisData/printProviders';

import { getFormTemplateList } from '@/api/system';

export default {
  components: { HiprintPreview },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchModel: {
        keyword: '',
        pageNum: 1,
        pageSize: 20,
        isDefault: null
      },
      tableData: [],
      tableLoading: false,
      tableTotal: 0,
      // 预览
      previewVisible: false,
      activeRowInfo: {}
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.getList(true);
      }
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getList(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getList();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageSize = pageSize;
      this.getList(true);
    },
    async getList(pageFirst = false) {
      if (pageFirst) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getFormTemplateList(this.searchModel);

      this.tableLoading = false;
      this.tableData = data.list || [];
      this.tableTotal = data.count;
    },
    handlePreview(row) {
      const provider = providerList[row.type];

      this.activeRowInfo = { ...provider, ...row };
      this.previewVisible = true;
    },
    handleChoose(row) {
      this.$emit('templateChoose', row);
      this.$emit('update:visible', false);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.header-title {
  font-size: 18px;
  color: #606266;
  font-weight: 700;
  line-height: 24px;

  .title-name {
    margin-left: 4px;
  }
}

::v-deep .el-dialog__header {
  border-bottom: #dddddd 1px solid;
}
</style>
